var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-box"},_vm._l((_vm.iconDataList),function(iconData,index){return _c('HoverableIconBig',{key:index,attrs:{"iconDataSpan":{ iconClass: iconData.iconClass, label: iconData.label }},on:{"click":function($event){return _vm.onClick(iconData.href)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }